module.exports = __webpack_public_path__ + "media/images/web/favicon/apple-icon-180x180-0c3bd03b786daf5587e63321f1d4dc70.png";